import React from 'react'
import styled from 'styled-components'

import '../styles/index.css'
import '../../static/fontawesome-free-5.11.2-web/css/all.css'
import '../../static/Google-fonts/Bungee/bungee.css'
import Header from './Header'
import Footer from './Footer'

const Container = styled.div`
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--color-primaryDark);
`
export default function Layout({ children }) {
  return (
    <>
      <Container>
        <div>
          <Header />
          {children}
        </div>
      </Container>
      <Footer />
    </>
  )
}
